import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientGuideCmsAlignments = (state, patientId) =>
  allModelsSelector(state, 'PatientGuideCmsAlignment', (p) => p.patientId === patientId);
